import { createFileRoute } from "@tanstack/react-router";
import { Chat } from "@/components/Chat";
import { useConversations } from "@/hooks/useConversations";

export const Route = createFileRoute("/_authenticated/c/$conversationId")({
  component: ChatRoute,
});

function ChatRoute() {
  const { conversationId } = Route.useParams();
  const { auth } = Route.useRouteContext();
  const navigate = Route.useNavigate();
  const { create, refresh } = useConversations();

  const handleNewChat = async () => {
    const id = await create();
    navigate({ to: "/c/$conversationId", params: { conversationId: id } });
    refresh();
  };

  const handleMessageSent = () => {
    setTimeout(refresh, 2000);
  };

  return (
    <Chat
      key={conversationId}
      userId={auth.user?.id ?? ""}
      conversationId={conversationId}
      onNewChat={handleNewChat}
      onMessageSent={handleMessageSent}
    />
  );
}
